// src/socket.ts

import {
  io,
  Socket,
} from "socket.io-client";

// =====================================================
// SOCKET SERVER
// =====================================================

const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

// =====================================================
// GET CURRENT AUTH TOKEN
// =====================================================

const getAuthToken = (): string | null => {
  return localStorage.getItem("token");
};

// =====================================================
// CREATE SOCKET
// =====================================================

const socket: Socket = io(
  SOCKET_URL,
  {
    transports: ["websocket"],

    // We control when the initial connection happens.
    autoConnect: false,

    withCredentials: false,

    auth: {
      token: getAuthToken(),
    },
  }
);

// =====================================================
// CONNECT
// =====================================================

export const connectSocket = () => {
  const token =
    getAuthToken();

  // Always refresh auth before connecting.
  socket.auth = {
    token,
  };

  if (!socket.connected) {
    socket.connect();
  }
};

// =====================================================
// REFRESH AUTHENTICATED SOCKET
// =====================================================
//
// Call this after login.
//
// If the socket was connected as a guest,
// reconnect it using the newly-created JWT.
//

export const refreshSocketAuth = () => {
  const token =
    getAuthToken();

  socket.auth = {
    token,
  };

  if (socket.connected) {
    socket.disconnect();
  }

  socket.connect();
};

// =====================================================
// LOGOUT SOCKET
// =====================================================
//
// Removes the authenticated socket.
//
// We reconnect as a guest because guests are still
// allowed to play against AI.
//

export const logoutSocket = () => {
  if (socket.connected) {
    socket.disconnect();
  }

  socket.auth = {
    token: null,
  };

  socket.connect();
};

// =====================================================
// CONNECTION EVENTS
// =====================================================

socket.on("connect", () => {
  console.log(
    "✅ Connected to WebSocket:",
    socket.id
  );
});

socket.on(
  "disconnect",
  (reason) => {
    console.log(
      "🔌 WebSocket disconnected:",
      reason
    );
  }
);

socket.on(
  "connect_error",
  (error) => {
    console.error(
      "❌ WebSocket connection error:",
      error.message
    );
  }
);

// =====================================================
// INITIAL CONNECTION
// =====================================================

connectSocket();

// =====================================================
// EXPORT
// =====================================================

export default socket;